import React, { useState, useEffect } from 'react';
import Home from '../../views/Home/Home';
import { Link } from 'react-router-dom';
import { useCurrentUser } from '../../services/AuthContext/AuthContext';
import { useStorage } from '../../services/Firestore/Resources';

export default () => {
  const user = useCurrentUser();
  const onlyDepartment = localStorage.getItem(user.id + 'onlyDepartment') === 'true';
  const [storage, storageLoading] = useStorage(user?.home);
  const [home, setHome] = useState(null);

  useEffect(() => {
    if (user && !storageLoading) {
      let thisHome = {};
      thisHome.id = storage?.lineage[0];
      if (onlyDepartment) {
        thisHome.departmentName = storage?.name;
        thisHome.departmentId = user.home;
      } else {
        thisHome.departmentName = null;
        thisHome.departmentId = null;
      }
      setHome(thisHome);
    }
  }, [user, storage, storageLoading, onlyDepartment]);

  if (!user.home) {
    return (
      <h3>
        Welcome {user.name}
        <br />
        <Link to='my-account'>Click here to select a home department</Link>
      </h3>
    );
  }

  if (storageLoading || home === null) {
    return <p>Loading...</p>;
  }
  return <Home myHome={home} />;
};
